module.exports = __webpack_public_path__ + "static/Paris Demo-96412c203fecfaa64bd6f1903a3a4146.mp4";